import { FILING_LABEL, QUOTE_LABEL, BILLING_LABEL, ENTRY_LABEL } from "@/lib/constants";

const TONES = {
  submitted: "bg-amber-50 text-amber-800 border-amber-200",
  priced: "bg-blue-50 text-blue-800 border-blue-200",
  purchased: "bg-emerald-50 text-emerald-800 border-emerald-200",
  declined: "bg-red-50 text-red-700 border-red-200",
  payment_received: "bg-slate-100 text-slate-700 border-slate-200",
  filing_submitted: "bg-blue-50 text-blue-800 border-blue-200",
  state_processing: "bg-amber-50 text-amber-800 border-amber-200",
  certificate_active: "bg-emerald-50 text-emerald-800 border-emerald-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
  paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  paid_up: "bg-emerald-50 text-emerald-800 border-emerald-200",
  due: "bg-amber-50 text-amber-800 border-amber-200",
  past_due: "bg-red-50 text-red-700 border-red-200",
  not_required: "bg-emerald-50 text-emerald-800 border-emerald-200",
  payment: "bg-emerald-50 text-emerald-800 border-emerald-200",
  refund: "bg-red-50 text-red-700 border-red-200",
  charge: "bg-amber-50 text-amber-800 border-amber-200",
  credit: "bg-blue-50 text-blue-800 border-blue-200",
  in_review: "bg-blue-50 text-blue-800 border-blue-200",
  info_needed: "bg-amber-50 text-amber-800 border-amber-200",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  denied: "bg-red-50 text-red-700 border-red-200",
  closed: "bg-slate-100 text-slate-700 border-slate-200",
};

export const StatusPill = ({ status, testId, label }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 font-mono text-[11px] font-semibold uppercase tracking-wide ${TONES[status] || TONES.pending}`}
  >
    {label || FILING_LABEL[status] || QUOTE_LABEL[status] || BILLING_LABEL[status] || ENTRY_LABEL[status] || status}
  </span>
);
